var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoiBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0.1,
    stdDeviation: 0.3,
    floodColor: "grey"
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: "50%",
    r: 4,
    style: {
      fill: "black",
      filter: "url(#shadow)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoiBackground);
export default __webpack_public_path__ + "static/media/poiBackground.efa21cd2faea27508fae20e158203fad.svg";
export { ForwardRef as ReactComponent };